import { FuelRecievingVoucherStateTypes, FuelRecievingVoucherActionTypes } from "./FuelRecievingVoucher.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FuelRecievingVoucherStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FuelRecievingVoucherReducer = (
  state: FuelRecievingVoucherStateTypes = INITIAL_STATE,
  action: any
): FuelRecievingVoucherStateTypes => {
  switch (action.type) {
    case FuelRecievingVoucherActionTypes.FETCH_ALL_FUEL_RECIEVING_VOUCHER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelRecievingVoucherActionTypes.FETCH_ALL_FUEL_RECIEVING_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelRecievingVoucherActionTypes.FETCH_ALL_FUEL_RECIEVING_VOUCHER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelRecievingVoucherActionTypes.FETCH_ALL_FUEL_RECIEVING_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FuelRecievingVoucherActionTypes.FETCH_ONE_FUEL_RECIEVING_VOUCHER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelRecievingVoucherActionTypes.FETCH_ONE_FUEL_RECIEVING_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelRecievingVoucherActionTypes.FETCH_ONE_FUEL_RECIEVING_VOUCHER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelRecievingVoucherActionTypes.FETCH_ONE_FUEL_RECIEVING_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FuelRecievingVoucherReducer;
